// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styleHelpers-lineHeightInputLabel_cls1__2dIIH","cls2":"styleHelpers-lineHeightInputLabel_cls2__FtlVO styleHelpers-lineHeightInputLabel_cls1__2dIIH"};